import {
  CLEAR_INFO,
  SET_INFO,
} from './types';

export const INIT_STATE = {
  info: {
    id: null,
    mifosId: null,
    active: false,
    status: null,
    totalOutstanding: 0,
    transactionDate: null,
    maturesDate: null,
    prepaid: true,
    repayEvery: 1,
    principalAmount: 0,
    interestAmount: 0,
    promotionAmount: null,
    paymentMethod: 'CASH',
    client: null,
    branch: null,
    storage: null,
  },
};

const mutations = {
  [SET_INFO](state, info) {
    state.info = {
      ...state.info,
      ...info,
    };
  },
  [CLEAR_INFO](state) {
    state.info = { ...INIT_STATE.info };
  },
};

export default mutations;
